/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import Container from './Container';
import Item from './Item';
import { GridProps } from './types';

const GridTemp: any = Container;
GridTemp.Item = Item;

/**
 * UI Toolkit Grid
 * @public
 */
const Grid = GridTemp as GridProps;

export default Grid;
export type {
  GridProps,
  ContainerProps as GridContainerProps,
  ItemProps as GridItemProps
} from './types';
